/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

import { canUseDOM } from "fbjs/lib/ExecutionEnvironment"
import createStyleResolver from "./createStyleResolver"

type StyleResolverType = ReturnType<typeof createStyleResolver>
declare global {
  interface Window {
    __LS_GLOBAL_Resolver: StyleResolverType
  }
}

let _styleResolver: StyleResolverType | undefined

// Share 1 instance for all the web apps in browser
if (canUseDOM) {
  if (!window.__LS_GLOBAL_Resolver) {
    _styleResolver = createStyleResolver()
    window.__LS_GLOBAL_Resolver = _styleResolver
  } else {
    _styleResolver = window.__LS_GLOBAL_Resolver
  }
} else {
  _styleResolver = createStyleResolver()
}

export const styleResolver = _styleResolver

export const getStyleSheet = () => styleResolver.getStyleSheet()

export const getStyleElement = () => {
  const sheet = styleResolver.getStyleSheet()
  return `<style id=${sheet.id}>${sheet.textContent}</style>`
}

export const initStyleSheet = styleResolver.initStyleSheet.bind(styleResolver)
